import PageWrapper from "../../common/components/PageWrapper";
import { useGetBokjiroWelfareContentsAsAdminLazyQuery as useGetBokjiroLazyQuery } from "../../../lib/apollo/graphql/generated";
import { FETCH_SIZE } from "../../../utilities/constants";
import { useForm } from "../../../hooks/useForm";
import BokjiroList from "../components/BokjiroList";
import BokjiroSearchOptions from "../components/BokjiroSearchOptions";

export type WelfareFilters = {
  page: number;
  limit: number;
  welfareTypeId: string;
  welfareFamilyTypeIds: string[];
  welfareLifeCycleIds: string[];
  welfareCategoryIds: string[];
};

export default function WelfareRegisterContainer() {
  const [filters, onChange, onBatch] = useForm<WelfareFilters>({
    page: 1,
    limit: FETCH_SIZE,
    welfareTypeId: "",
    welfareFamilyTypeIds: [],
    welfareLifeCycleIds: [],
    welfareCategoryIds: [],
  });

  const [getBokjiro, { data, loading, refetch, networkStatus }] =
    useGetBokjiroLazyQuery({
      notifyOnNetworkStatusChange: true,
    });

  const isRefetching = networkStatus === 4;

  return (
    <PageWrapper className="flex-row gap-1">
      <BokjiroSearchOptions
        filters={filters}
        onChange={onChange}
        onSearch={() => {
          if (!filters.welfareTypeId) {
            return;
          }

          onBatch({
            ...filters,
            page: 1,
          });

          getBokjiro({
            variables: {
              ...filters,
              page: 1,
            },
          });
        }}
      />
      <BokjiroList
        isLoading={loading || isRefetching}
        data={data}
        page={filters.page}
        onPageChange={(newPage) => {
          if (loading || isRefetching) {
            return;
          }

          try {
            onChange("page", newPage);
          } finally {
            refetch({
              ...filters,
              page: newPage,
            });
          }
        }}
      />
    </PageWrapper>
  );
}
